import { IPage } from "./IPage";
import { ISearchType } from "./ISearchType";

export enum IClinicTab {
    careArea,
    roleGroup,
    carePerformerRequest,
    carePerformer
}

export interface IClinic {
    clinicId: number;
    organisationId: number;
    organisationClinicId: number;
    name: string;
    hsaId: string;
    clinicNumber: string;
    fkNumber?: string;
    visitingAddressPostalAddressId: number;
    visitingAddressContactName?: string;
    visitingAddressAddress: string;
    visitingAddressZipCode: string;
    visitingAddressCity: string;
    visitingAddressPhoneNumber?: string;
    visitingAddressAlternativePhoneNumber?: string;
    visitingAddressEmailAddress?: string;
}

export interface IClinicListItem {
    clinicId: number;
    clinicNumber: string;
    name: string;
}

export interface IClinicSearchParams extends IPage {
    searchType: ISearchType.Clinic;
    organisationId?: number;
}

export interface IClinicResponse {
    clinics: IClinicListItem[];
}